import React from 'react';
import './nav-header.css'


const Navheader = (props) => {
    return ( 
        <li className={props.stylee}>{props.title}</li>
     );
}
 
export default Navheader;